const gcalSettings = (
  state : Object = { },
  action : Object
) => {
  switch (action.type) {
    case 'FIREBASE_GCAL_SETTINGS_UPDATE_VALUE':
    {
      const newState = Object.assign({}, state)
      newState[action.label] = {
        loading: false,
        value: action.value ? action.value : {}
      }
      return newState
    }
    default:
      return state
  }
}

export default gcalSettings



// WEBPACK FOOTER //
// ./src/infra/reducers/gcal/gcalSettings.js